/**
 * Google Maps / Places API key for venue location autocomplete.
 * Set REACT_APP_GOOGLE_MAPS_API_KEY in .env (or in config/publicEnv for runtime).
 * Enable "Maps JavaScript API" and "Places API" in Google Cloud Console.
 */

import { getPublicConfig } from './runtimeEnv';

export function getGoogleMapsApiKey() {
  const fromEnv = (typeof process !== 'undefined' && process.env && process.env.REACT_APP_GOOGLE_MAPS_API_KEY) || '';
  const key = (fromEnv && fromEnv.trim()) || (getPublicConfig().REACT_APP_GOOGLE_MAPS_API_KEY || '').trim();
  return key || null;
}

/** Call once in dev to warn if key is missing (e.g. .env added but server not restarted). */
let _warnedMissingKey = false;
export function warnIfGoogleMapsKeyMissing() {
  if (_warnedMissingKey || typeof process === 'undefined') return;
  if (process.env.NODE_ENV !== 'development' || getGoogleMapsApiKey()) return;
  _warnedMissingKey = true;
  console.warn(
    '[placesConfig] REACT_APP_GOOGLE_MAPS_API_KEY is not set. Add it to .env and restart the dev server (stop npm run start, then run it again).'
  );
}

export function isPlacesAutocompleteAvailable() {
  return !!getGoogleMapsApiKey();
}
